import { useDocumentTitle } from '../hooks/useDocumentTitle';

export function AccessDenied() {
  useDocumentTitle('Access Denied');

  return (
    <div className="flex flex-col items-center justify-center min-h-screen">
      <h1 className="text-2xl font-bold mb-4">Access Denied</h1>
      <p className="text-gray-600">You don't have permission to access this resource.</p>
    </div>
  );
}
